var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ContractStatus"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.dataInfo.label))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.moneyFormat(_vm.dataInfo.value, _vm.dataInfo.moneyFormat)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }